export default __webpack_public_path__ + "static/media/msf_background_xl2.bca9004a.jpg";